import * as React from "react";
import { Facet } from "@elastic/react-search-ui";
import classnames from "classnames";
import OrderedCheckboxList from "./OrderedCheckboxList";
import { parseDisplayOrder } from "../../helper";

// Back-compat fallback: facets that were ordered via the former hardcode but don't yet
// carry an explicit `order` in their config. Remove once those pages set `order` in the
// settings form.
const FALLBACK_DISPLAY_ORDER = {
  learning_level: ['General Interest', 'Technical - Beginner', 'Technical - Intermediate', 'Technical - Advanced'],
};

export default function OpenSearchFacet(props) {
  const {field, label, show, hidden, order} = props;

  const css = {
    root: classnames({
      'facet': true,
      'facet--hidden': hidden,
    }),
  }

  // Admin-configured order (newline-separated) wins; otherwise fall back to any legacy
  // hardcoded order for this field. Empty → Search UI's default facet order.
  const configuredOrder = parseDisplayOrder(order);
  const customOrder = configuredOrder.length > 0 ? configuredOrder : (FALLBACK_DISPLAY_ORDER[field] || []);
  const view = customOrder.length > 0
    ? viewProps => <OrderedCheckboxList {...viewProps} customOrder={customOrder}/>
    : undefined;

  return (
    <div className={css.root}>
      <details open={true}>
        <summary>
          <span>{label}</span>
          <div className="facet__arrow"></div>
        </summary>
        <Facet field={field} show={show} label={label} filterType='any' view={view}/>
      </details>
    </div>
  );
}
